import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export default function Header({
	title,
	subtitle,
	action,
	className,
}: {
	title: string;
	subtitle?: string;
	action?: ReactNode;
	className?: HTMLAttributes<HTMLDivElement>["className"];
}) {
	return (
		<div className={cn("flex items-center justify-between mb-10 ", className)}>
			<div>
				<h1 className="text-xl text-grey-900 font-medium">{title}</h1>
				{subtitle && <p className="text-sm text-grey-700">{subtitle}</p>}
			</div>

			{action}
		</div>
	);
}
